import type { ServerCmsTypesProductSummary as ProductSummary } from "@reactivated";

const PLACEHOLDER = "\u00A0";
const TRANSPARENT_PIXEL =
    "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

const placeholderFacet = (index: number) => ({
    facet_slug: `placeholder-${index}`,
    value_slug: "",
    name: PLACEHOLDER,
    display_value: PLACEHOLDER,
});

export const skeletonProduct = (sku: string): ProductSummary => ({
    title: PLACEHOLDER,
    url: "",
    sku,
    image: {
        title: "",
        description: "",
        default_alt_text: "",
        width: 1,
        height: 1,
        brightness: null,
        url: TRANSPARENT_PIXEL,
        renditions: {
            original: {
                spec: "original",
                url: TRANSPARENT_PIXEL,
                width: 1,
                height: 1,
                size: 0,
                mimetype: "image/gif",
            },
        },
        imageData: null,
    },
    msrp: {
        amount: "0",
        currency: {
            code: "USD",
            iso_4217_code: "840",
            sub_unit: 2,
            name: "US Dollar",
        },
        decimal_places: 2,
        formatted: PLACEHOLDER,
    },
    facet_values: [],
    featured_facets: [
        placeholderFacet(0),
        placeholderFacet(1),
        placeholderFacet(2),
        placeholderFacet(3),
    ],
    product_type_name: null,
    status: "active",
});
